// src/hooks/useGenieHireDashboard.js
import { useState, useEffect } from "react";
import { dashboardService } from "../services/dashboardService";
import { formatLocalDate } from "../utils/dateHelpers";

export const useGenieHireDashboard = (dateRange, selectedOrg) => {
  const [data, setData] = useState({
    jobPostings: [],
    interviewSchedules: [],
    resumeParsed: [],
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      const params = new URLSearchParams();
      const [start, end] = dateRange;

      if (start) params.append("start_date", formatLocalDate(start));
      if (end) params.append("end_date", formatLocalDate(end));
      params.append("organization_name", selectedOrg || "All Organizations");

      try {
        const data = await dashboardService.getGenieHireDashboard(params);
        setData({
          jobPostings: data.job_descriptions || [],
          interviewSchedules: data.interview_schedules?.results || [],
          resumeParsed: data.resume_parsed?.resume_parsed_date || [],
        });
      } catch (err) {
        console.error("Error fetching GenieHire dashboard:", err);
      } finally {
        setLoading(false);
      }
    };

    fetch();
  }, [dateRange, selectedOrg]);

  return { ...data, loading };
};